import {useEffect, useRef, useState} from "react";
import BllinkTime from "../../../common/utils/time";
import {createPdfFromHtml} from "../../../common/shared/statelessMethods";
import {fileToBase64} from "../../../../utils/fileToBase64";
import {useTranslation} from "react-i18next";
import {StyledPdfApplication} from "./BankChargeApplicationPage.styled";

export function BankChargeApplicationPage() {

    const {t} = useTranslation();
    const container = useRef();

    const [pdfImage, setPdfImage] = useState(null);
    const [readyToBuild, setReadyToBuild] = useState(false);
    const [tenantDetails, setTenantDetails] = useState(null);
    const [bankChargeData, setBankChargeData] = useState(null);
    const [buildingAddress, setBuildingAddress] = useState(null);

    useEffect(async () => {
        if (pdfImage == null) {
            // load dynamically to exclude from common bundle
            const module = await import('../../../managers/autoBankCharge/pdf');
            setPdfImage(module.pdfImage)
        }
    });

    useEffect(() => {
        window.addEventListener('message', handleWindowMessage);
        return () => window.removeEventListener('message', handleWindowMessage);
    }, []);

    useEffect(async () => {
        if (readyToBuild) {
            try {
                const options = { save: false, ignoreLastPage: true };
                const file = await createPdfFromHtml(container.current, '', options);
                const imageBase64 = await fileToBase64(file);
                const imageName = `${tenantDetails.apartmentNumber},${buildingAddress.full_address}${t('auto_charge.fileName')}.pdf`;
                window.postMessage({
                    bankChargeApplication: true,
                    imageBase64,
                    imageName,
                    bankChargeData: {
                        bankCode: bankChargeData.bankCode,
                        branchNumber: bankChargeData.branchNumber,
                        accountNumber: bankChargeData.accountNumber,
                    }
                });
                setReadyToBuild(false); // allow to rebuild
            } catch (e) {
                window.postMessage({ iframeError: true, error: e });
            }

        }
    }, [readyToBuild]);


    function handleWindowMessage(event) {
        if (event.data?.applicationData) {
            setBankChargeData(event.data.bankChargeData);
            setTenantDetails(event.data.tenantDetails);
            setBuildingAddress(event.data.buildingAddress);
            setReadyToBuild(true);
        }
    }

    return (
        <StyledPdfApplication>
            <div className='wrapper' ref={container}>
                <div className='bg'>
                    <img src={pdfImage} alt="document" />
                </div>
                <p className='pdf-data address'>{buildingAddress?.full_address}</p>
                <p className='pdf-data phone'>{tenantDetails?.phone}</p>
                <p className='pdf-data phone-in-table'>{tenantDetails?.phone}</p>
                <p className='pdf-data email'>{tenantDetails?.email}</p>
                <p className='pdf-data name'>{tenantDetails?.name}</p>
                <p className='pdf-data check'>&#10003;</p>
                <p className='pdf-data owner-id'>{bankChargeData?.ownerId}</p>
                <div className='pdf-data signature'>
                    <img src={bankChargeData?.signature} alt="signature" />
                </div>
                <p className='pdf-data bank-code'>{bankChargeData?.bankCode}</p>
                <p className='pdf-data branch-code-right'>{bankChargeData?.branchNumber}</p>
                <p className='pdf-data bank-name'>{bankChargeData?.bankName}</p>
                <p className='pdf-data account'>{bankChargeData?.accountNumber}</p>
                <p className='pdf-data date'>{BllinkTime.parseDate(bankChargeData?.date)}</p>
                <p className='pdf-data branch'>{bankChargeData?.branchNumber}</p>
            </div>
        </StyledPdfApplication>
    );
}
